<template>
  <div class="flex items-center h-100" :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <edit-icon
      v-b-tooltip.hover.html="edit_product"
      size="1.3x"
      class=" hover:text-primary cursor-pointer"
      @click="$router.push({ name: 'admin-product-edit',query:{edit_product_uuid:params.data.product_uuid} })"
    />
    <trash-2-icon
      v-b-tooltip.hover.html="delete_product"
      size="1.3x"
      class="ml-3 hover:text-primary cursor-pointer"
      @click="ConfirmDelete"
    />
  </div>
</template>

<script>
import { EditIcon,Trash2Icon } from 'vue-feather-icons'

export default {
  name: 'CellRendererActions',
  components: {
    EditIcon,
    Trash2Icon
  },
  data:() =>({
    edit_product: { title: 'Edit Product' },
    delete_product: { title: 'Delete Product' },

  }),

  methods: {
    Edit () {
      // console.log('Edit')
      // this.$emit('refresh-data', 1)
      console.log(this)
    },
    ConfirmDelete () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Are you sure?',
        text: 'You will not be able to recover this Product!',
        accept: this.Delete,
        acceptText: 'Delete'
      })
    },
    Delete () {

      this.$store.dispatch("product/Delete", this.params.data.product_uuid)
        .then(() => {
          this.params.data.refreshData()
          this.ShowSuccessMessage({
            title: 'Product Deleted',
            text: 'The selected Product was successfully deleted'
          })
        })
        .catch(err => {
          this.ShowErrorMessage({ title: 'Error', text: err })
        })
    },
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    },
  }
}
</script>
<style lang="scss">
  @import "src/assets/scss/tooltip";
</style>
